// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as IconGridSizes$Showside from "../icons/IconGridSizes.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as GridDensityZoomProvider$Showside from "../context/GridDensityZoomProvider.bs.js";
function GridDensityZoomSelector(Props) {
  var value = Props.value;
  var onChange = Props.onChange;
  ViewportContext$Showside.use(undefined);
  var match = GridDensityZoomProvider$Showside.use(undefined);
  var getAriaLabel = function (gridColumn) {
    switch (gridColumn) {
      case /* OneColumnGrid */0:
        return "One Column";
      case /* TwoColumnGrid */1:
        return "Two Columns";
      case /* ThreeColumnGrid */2:
        return "Three Columns";
      case /* FourColumnGrid */3:
        return "Four Columns";
      case /* FiveColumnGrid */4:
        return "Five Columns";
      case /* SixColumnGrid */5:
        return "Six Columns";
      case /* SevenColumnGrid */6:
        return "Seven Columns";
      case /* EightColumnGrid */7:
        return "Eight Columns";
      case /* TwelveColumnGrid */8:
        return "Twelve Columns";
    }
  };
  return React.createElement("div", {
    className: CSS$Showside.prefix("inline-flex")
  }, Belt_Array.map(match.options, function (option) {
    var active = option === value;
    var tmp;
    var exit = 0;
    switch (option) {
      case /* OneColumnGrid */0:
        tmp = React.createElement(IconGridSizes$Showside.SizeOne.make, {
          className: CSS$Showside.prefix("w-7 h-7"),
          active: active
        });
        break;
      case /* TwoColumnGrid */1:
        tmp = React.createElement(IconGridSizes$Showside.SizeTwo.make, {
          className: CSS$Showside.prefix("w-7 h-7"),
          active: active
        });
        break;
      case /* ThreeColumnGrid */2:
        tmp = React.createElement(IconGridSizes$Showside.SizeThree.make, {
          className: CSS$Showside.prefix("w-7 h-7"),
          active: active
        });
        break;
      case /* FourColumnGrid */3:
        tmp = React.createElement(IconGridSizes$Showside.SizeFour.make, {
          className: CSS$Showside.prefix("w-7 h-7"),
          active: active
        });
        break;
      case /* FiveColumnGrid */4:
      case /* SixColumnGrid */5:
      case /* SevenColumnGrid */6:
      case /* EightColumnGrid */7:
      case /* TwelveColumnGrid */8:
        exit = 1;
        break;
    }
    if (exit === 1) {
      tmp = React.createElement(IconGridSizes$Showside.SizeFive.make, {
        className: CSS$Showside.prefix("w-7 h-7"),
        active: active
      });
    }
    return React.createElement("button", {
      "aria-label": getAriaLabel(option),
      "aria-selected": active,
      className: CSS$Showside.prefix(Cn.make(["bg-transparent p-1 cursor-pointer", active ? "text-primary" : "text-secondary hover:text-primary"])),
      title: getAriaLabel(option),
      onClick: function (param) {
        return Curry._1(onChange, option);
      }
    }, tmp);
  }));
}
GridDensityZoomSelector.displayName = "GridDensityZoomSelector";
var make = GridDensityZoomSelector;
export { make };
/* react Not a pure module */